import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';

import { Button, Text, Small, Panel, H4, Table, TableFigure, Badge, Input } from '@bigcommerce/big-design';

const PurchaseOrderLine = ({ payload, purchaseOrderLines, adjustedTotal, setAdjustedTotal, taxSetting, shippingTotal, setShippingTotal, bigcommerceSettings }) => {
  const format = (value) => {
    let formattedValue = "";

    if(bigcommerceSettings.currency_symbol_location === 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }
    
    formattedValue += parseFloat(value).toFixed(bigcommerceSettings.decimal_places)

    if(bigcommerceSettings.currency_symbol_location !== 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }

    formattedValue = formattedValue.replace('.', bigcommerceSettings.decimal_separator)

    return formattedValue;
  }

  const setTotal = (event) => {
    let value = event.target.value;
    setAdjustedTotal(value)
  }

  const setShipping = (event) => {
    let value = event.target.value;
    setShippingTotal(value)
  }

  const subtotal = () => {
    let subtotal = 0.0;

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variantId;
      let quantity = purchaseOrderLines.lineDetails[key].quantity;
      let unitPrice = purchaseOrderLines.lineDetails[key].adjustedUnitCost || purchaseOrderLine.supplier_price;
    
      subtotal = subtotal + (quantity * unitPrice);
    })

    return subtotal;
  }

  const taxes = () => {
    if(!taxSetting) {
      return 0.0;
    }

    let taxes = 0.0;

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variantId;
      let quantity = purchaseOrderLines.lineDetails[key].quantity;
      let unitPrice = purchaseOrderLines.lineDetails[key].adjustedUnitCost || purchaseOrderLine.supplier_price;
      let taxTotal = parseFloat(purchaseOrderLines.lineDetails[key].adjustedTax);

      if(taxTotal !== 0.0) {
        taxTotal = taxTotal || ((quantity * unitPrice) * (taxSetting?.rate || 0)/100.0);
      }

      taxes = taxes + taxTotal;
    })

    return taxes;
  }

  return(
    <div className="flex-1 text-right left-15">
      <div className="flex-container flex-column">
        <div className="flex-1">
          <strong>Subtotal</strong>: { format(subtotal()) }
        </div>

        <div className="flex-1">
          <strong>Taxes</strong>: { format(taxes()) }
        </div>

        <Input  
          label="Shipping total" 
          placeholder="Shipping total" 
          id="shipping_total" 
          type="number"
          min="0"
          value={ shippingTotal }
          onChange={(e) => setShipping(e)}
        />

        <div className="flex-1">
          <strong>Total</strong>: { format(subtotal() + taxes() + (parseFloat(shippingTotal) || 0.0)) }
        </div>
      </div>

      <hr/>

      <Input 
        required 
        label="Adjusted total" 
        placeholder="Adjusted total" 
        id="adjusted_total" 
        type="number"
        min="0"
        value={ adjustedTotal }
        onChange={(e) => setTotal(e)}
      />
    </div>
  )

}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderLine);